import { cn } from '@/shared/lib/cn';
import styles from './Burger.module.css';

export interface BurgerProps {
  open: boolean;
  className?: string;
}

/**
 * Значок «меню» ☰, который плавно превращается в крестик ✕.
 *
 * Живёт в shared/ui, потому что рисуется в двух местах сразу: в кнопке шапки и
 * в кнопке самого полноэкранного меню (widgets/Sidebar). Меню накрывает шапку
 * целиком, поэтому кнопка под ним — другая; чтобы при открытии ничего не
 * дёрнулось, обе рисуют один и тот же значок в одинаковой площадке
 * `--header-btn`. Раньше шапка морфила бургер, а меню показывало иконку `X`
 * в кнопке 42px — значок менялся и прыгал на месте.
 *
 * @use кнопка-переключатель мобильного меню; ☰ превращается в ✕.
 */
export function Burger({ open, className }: BurgerProps) {
  return (
    <span className={cn(styles.burger, open && styles.open, className)} aria-hidden>
      <span />
      <span />
      <span />
    </span>
  );
}
